import { AuthenticationManager } from "@core/managers/authentication.manager";
import { Logger } from "@core/helpers/logger.helpers";
import { RecruitmentsService } from "@core/services";

import { ETAB_ROUTES } from "@etab/config";

import { RecruitmentNumbers } from "@core/models";

const creationRoute = { name: ETAB_ROUTES.creation.root.name };
const dashboardInProgressRoute = { name: ETAB_ROUTES.dashboard.tabs.inProgress.name };
const dashboardUpcomingRoute = { name: ETAB_ROUTES.dashboard.tabs.upcoming.name };
const landingRoute = { name: ETAB_ROUTES.auth.landing.name };

/**
 * Smart redirect process will decide the best next route based on different criteria
 * and navigate to this route
 * @param {VuerouterRoute} to
 * @param {VuerouterRoute} from
 * @param {VuerouterRoute} next
 */
export async function smartRedirectProcess(to, from, next) {
  let nextRoute;
  try {
    const isUserAuthenticated = await AuthenticationManager.isUserAuthenticated();
    if (isUserAuthenticated) {
      // we smart redirect only for authenticated users
      nextRoute = await getSmartRedirectionRoute();
    } else {
      // if user is not authenticated, go to landing page
      nextRoute = landingRoute;
    }
  } catch (error) {
    Logger.warn("smartRedirectProcess failure", error);
    // if anything happens badly, go to creation route
    nextRoute = creationRoute;
  }
  next(nextRoute);
}

/**
 * Smart redirection depending on different criteria
 * @returns next route
 */
export async function getSmartRedirectionRoute() {

  const recruitmentNumbers = new RecruitmentNumbers(await RecruitmentsService.getNumbers());

  if (recruitmentNumbers.hasInProgressRecruitments()) {
    return dashboardInProgressRoute;
  }
  if (recruitmentNumbers.hasUpcomingRecruitments()) {
    return dashboardUpcomingRoute;
  }

  return creationRoute;
}
